import React, { useEffect, useMemo, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import { useNavigate, useParams } from "react-router-dom";
import {
  generateJobDepartmentAPI,
  generateJobLebelesAPI,
  getProductinUniqueDepartment,
  getProductionJobsData,
} from "../../Redux/orders";
import FullScreenLoader from "../../Components/FullScreenLoader";
import {
  Dropdown,
  Empty,
  Image,
  Menu,
  message,
  Modal,
  Select,
  Spin,
  Table,
  TableColumnsType,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import {
  CapitalizeFirstWord,
  DefaultNoImageFound,
  generateDeptTabsStyle,
  getDepartmentTagTheme,
  getThumbnailUrl,
  momentDateTime,
  momentDDMMYY,
} from "../../../helpers/utils";
import { decryptByText } from "../../../helpers/bycrypt";
import { svg } from "../../../Assets/svg";
import Dymo from "dymo-connect";
import PrintPreviewModal from "./Components/Modals/PrintPreviewModal";
import PrinterConnectionErrorModal from "./Components/Modals/PrinterConnectionErrorModal";
import { BtnLoader } from "../../../Components/Components";
import {
  PrinterOutlined,
  SyncOutlined,
  PlusOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { JobLabelXml } from "../../../helpers/JobLabelXml";
import {
  PagePermissionNameData,
  usePermissionsChecker,
} from "../../../helpers/permissionModule";
import DescriptionWithShowMore from "../../../helpers/DescriptionWithShowMore";

const Jobs = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const options = {
    hostname: "127.0.0.1",
    port: 41951,
  };

  const dymo = new Dymo(options);

  const { orderDetails, getOrderProductionDepartment, productionJobsData } =
    useAppSelector((state: RootState) => state.orders);
  const USER_PERMISSIONS = usePermissionsChecker(PagePermissionNameData?.JOBS);
  const { getOrderProductionDepartmentLoading, getProductionJobsDataLoading } =
    useAppSelector((state: RootState) => state.loading);
  const [activeKey, setActiveKey] = useState<any>("all");
  const [messageApi, contextHolder] = message.useMessage();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadingAction, setDownloadingAction] = useState<string | null>(
    null,
  );
  const [isSheetDropdownOpen, setIsSheetDropdownOpen] = useState(false);
  const [downloadJobLebelsLoading, setDownloadJobLebelsLoading] =
    useState(false);

  // dymo printer states
  const [renderPrint, setRenderPrint] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [previewImage, setPreviewImage] = useState<any>([]);
  const [isOpenConnectionErrorModal, setIsOpenConnectionErrorModal] =
    useState(false);
  const [connectionStates, setConnectionStates] = useState({
    isPrinterError: false,
    isConnectionError: false,
    isConnectSuccess: false,
    isPrinterFound: false,
    connectedPrinterName: "",
  });
  const [connectionLoader, setConnectionLoader] = useState(false);
  const [refreshConnection, setRefreshConnection] = useState(1);

  const [selectedCategorySnapShot, setSelectedCategorySnapShot] =
    useState<any>("");
  const handleCheckConnection = async () => {
    try {
      setConnectionLoader(true);
      // dymo-connect defaults to port 41951
      const printers: any = await dymo.getPrinters();

      if (printers?.success) {
        if (printers?.data?.length === 0) {
          setConnectionStates((prev) => ({
            ...prev,
            isPrinterError: true,
            isConnectionError: false,
            isConnectSuccess: true,
            isPrinterFound: false,
            connectedPrinterName: "",
          }));
        } else {
          const connectedPrinter =
            printers?.data?.find((p: any) => p.connected) ||
            printers?.data?.[0];

          setConnectionStates((prev) => ({
            ...prev,
            isPrinterError: false,
            isConnectionError: false,
            isConnectSuccess: true,
            isPrinterFound: true,
            connectedPrinterName: connectedPrinter?.name || "",
          }));
        }
      } else {
        setConnectionStates((prev) => ({
          ...prev,
          isPrinterError: false,
          isConnectionError: true,
          isConnectSuccess: false,
          isPrinterFound: false,
          connectedPrinterName: "",
        }));
      }
    } catch (error) {
      setConnectionStates((prev) => ({
        ...prev,
        isPrinterError: false,
        isConnectionError: true,
        isConnectSuccess: false,
        isPrinterFound: false,
        connectedPrinterName: "",
      }));
      // setConnectionStates(true);
    } finally {
      setTimeout(() => {
        if (refreshConnection > 1) {
          messageApi.success("Connection refreshed successfully");
        }
        setConnectionLoader(false);
      }, 500);
    }
  };

  useEffect(() => {
    handleCheckConnection();
  }, [refreshConnection]);

  useEffect(() => {
    if (id) {
      dispatch(
        getProductinUniqueDepartment({
          order_id: id,
          categories_snapshot_id: selectedCategorySnapShot,
        }),
      );
    }
  }, [id, selectedCategorySnapShot]);

  useEffect(() => {
    if (activeKey && id) {
      const payload = {
        order_id: id,
        department_id: activeKey === "all" ? "" : activeKey,
        categories_snapshot_id: selectedCategorySnapShot,
      };
      dispatch(getProductionJobsData(payload));
    }
  }, [activeKey, id, selectedCategorySnapShot]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 1024); // iPad + Mobile
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const items: TabsProps["items"] = useMemo(() => {
    if (getOrderProductionDepartment?.length > 0) {
      const data = getOrderProductionDepartment.map((elem: any) => ({
        key: elem?._id,
        label: `${elem?.name} ${
          elem?.incomplete_count > 0 || elem?.complete_count > 0
            ? `(${elem?.complete_count}/${
                elem?.incomplete_count + elem?.complete_count
              })`
            : ""
        }`,
        children: "",
      }));
      const totalComplateIncomplateTask = getOrderProductionDepartment.reduce(
        (acc: any, elem: any) => {
          acc.complete_count += elem?.complete_count;
          acc.incomplete_count += elem?.incomplete_count;
          return acc;
        },
        { complete_count: 0, incomplete_count: 0 },
      );
      return [
        {
          key: "all",
          label: `All (${totalComplateIncomplateTask?.complete_count}/${
            totalComplateIncomplateTask?.incomplete_count +
            totalComplateIncomplateTask?.complete_count
          })`,
        },
        ...data,
      ];
    }
  }, [getOrderProductionDepartment]);

  const deptTabsCss = useMemo(() => {
    return generateDeptTabsStyle(
      "jobsDeptTabs",
      getOrderProductionDepartment,
      activeKey,
    );
  }, [getOrderProductionDepartment, activeKey]);

  const columns: TableColumnsType<any> = [
    {
      title: "Product",
      onCell: (record: any) => ({ rowSpan: record.rowSpan }),
      render: (_: any, record: any) => {
        return (
          <>
            <div className="d-flex gap-2">
              <Image
                src={
                  record?.product?.image &&
                  record?.product?.image !== DefaultNoImageFound
                    ? getThumbnailUrl(record?.product?.image)
                    : DefaultNoImageFound
                }
                alt={record?.product?.name}
                className="rounded-2 object-fit-cover border w-100 h-100"
                rootClassName="img-45"
                fallback={DefaultNoImageFound}
                preview={{
                  mask: <EyeOutlined />, // 👈 custom icon here
                }}
              />
              <div>
                <p
                  className="p-0 m-0"
                  style={{
                    color:
                      record?.item_type == "bom_part"
                        ? "#EA7E58"
                        : record?.item_type == "component"
                        ? "#A756AC"
                        : "#58BF6E",
                  }}
                >
                  {record?.item_type == "bom_part"
                    ? "Part"
                    : record?.item_type == "component"
                    ? "Component"
                    : "Variant"}
                </p>
                <h6 className="fw-semibold mb-0 text-dark fs-6 mb-1">
                  {["bom_part", "component", "service"]?.includes(record?.item_type)
                    ? record?.name
                    : record?.product?.variants?.variant_name}
                </h6>
                <h6
                  className="fw-semibold mb-0 text-dark"
                  style={{ fontSize: "12px" }}
                >
                  Qty - {record?.product?.variant_qty}
                </h6>
              </div>
            </div>
            <small className="text-muted fw-normal fs-8 d-inline-block mt-1 device-w-fix">
              <DescriptionWithShowMore
                description={record?.product?.description}
              />
            </small>
          </>
        );
      },
      width: "16%",
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "5%",
      render: (_: any, record: any) => (
        <div>
          <span>{record.qty || 0}</span>
          <div className="fs-8 text-secondary mt-1">
            {record?.product?.labelInQuotation || "Qty"}
          </div>
        </div>
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      render: (unit: any) => <span>{unit || "-"}</span>,
      width: "4%",
    },
    {
      title: "Department",
      dataIndex: "department_id",
      width: "9%",
      render: (department_id: any, record: any) => (
        <span>{department_id?.name ? department_id?.name : "-"}</span>
      ),
    },
    {
      title: "Machine",
      dataIndex: "machine_id",
      width: "9%",
      render: (machine_id: any, record: any) => (
        <span>{machine_id?.name ? machine_id?.name : "-"}</span>
      ),
    },
    {
      title: "Employee",
      dataIndex: "employee_ids",
      width: "9%",
      render: (employee_ids: any, record: any) => (
        <span>
          {employee_ids?.length > 0
            ? employee_ids
                ?.map(
                  (elem: any) =>
                    CapitalizeFirstWord(decryptByText(elem?.first_name)) +
                    " " +
                    CapitalizeFirstWord(decryptByText(elem?.last_name)),
                )
                ?.join(", ")
            : "-"}
        </span>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "start_at",
      width: "9%",
      render: (start_at: any, record: any) => {
        return start_at ? momentDDMMYY(start_at) : "-";
      },
    },
    {
      title: "End Date",
      dataIndex: "end_at",
      width: "9%",
      render: (end_at: any, record: any) => {
        return end_at ? momentDDMMYY(end_at) : "-";
      },
    },
    {
      title: "Manufactured Qty",
      dataIndex: "manufactured_qty",
      width: "6%",
      render: (manufactured_qty: any, record: any) => (
        <span>{manufactured_qty ? manufactured_qty : 0}</span>
      ),
    },
    {
      title: "Pending Qty",
      dataIndex: "pending_qty",
      width: "6%",
      render: (pending_qty: any, record: any) => (
        <span>{pending_qty ? pending_qty : 0}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "8%",
      render: (status: any, record: any) => {
        const statusClassMap = {
          started: "designPendingStatus",
          completed: "approvedStatus",
          scheduled: "draftStatus",
        };

        const displayLabel =
          status === "init"
            ? ""
            : status === "started"
            ? "Started"
            : status === "completed"
            ? "Completed"
            : "Scheduled";
        return displayLabel == "" ? (
          <>-</>
        ) : (
          <span
            className={`d-inline-flex align-items-center billStatus ${
              statusClassMap[status as keyof typeof statusClassMap] || ""
            }`}
          >
            {svg.dotIcon}
            {displayLabel}
          </span>
        );
      },
    },
  ];

  const handleDownloadJobs = (action: string) => {
    const payload = {
      order_id: id,
      department_id: activeKey,
      action: action,
    };
    const actionLabels: Record<string, string> = {
      production_sheet: "Production Sheet per Department",
      master_production_sheet: "Master Production Sheet",
      purchasing_checklist: "Purchasing Checklist",
    };
    const label = actionLabels[action] || "Sheet";
    messageApi.open({
      type: "loading",
      content: `${label} Download In Progress..`,
      duration: 0,
    });
    setDownloadLoading(true);
    setDownloadingAction(action);
    setIsSheetDropdownOpen(true);
    dispatch(
      generateJobDepartmentAPI({
        payload: payload,
        onSuccess: () => {
          setDownloadLoading(false);
          setDownloadingAction(null);
          setIsSheetDropdownOpen(false);
          messageApi?.destroy();
        },
        onError: () => {
          setDownloadLoading(false);
          setDownloadingAction(null);
          setIsSheetDropdownOpen(false);
          messageApi?.destroy();
        },
      }),
    );
  };

  const productionSheetMenuItems = useMemo(() => {
    const items = [
      {
        key: "production_sheet",
        label: "Production Sheet per Department",
      },
      {
        key: "master_production_sheet",
        label: "Master Production Sheet",
      },
      {
        key: "purchasing_checklist",
        label: "Purchasing Checklist",
      },
    ];

    return items.map((item) => {
      const isCurrentLoading =
        downloadLoading && downloadingAction === item.key;
      const isDisabled = downloadLoading && downloadingAction !== item.key;

      return {
        key: item.key,
        disabled: isDisabled || isCurrentLoading,
        onClick: ({ domEvent }: any) => {
          domEvent?.stopPropagation?.();
          if (!downloadLoading) {
            handleDownloadJobs(item.key);
          }
        },
        label: (
          <div
            className="text-black d-flex align-items-center justify-content-between gap-3"
            style={{
              minWidth: "230px",
              cursor: isCurrentLoading
                ? "wait"
                : isDisabled
                ? "not-allowed"
                : "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (!downloadLoading) {
                handleDownloadJobs(item.key);
              }
            }}
          >
            <span>{item.label}</span>
            {isCurrentLoading && <Spin size="small" />}
          </div>
        ),
      };
    });
  }, [downloadLoading, downloadingAction, id, activeKey]);

  const handleRender = async () => {
    if (
      connectionStates?.isPrinterError ||
      connectionStates?.isConnectionError
    ) {
      setIsOpenConnectionErrorModal(true);
      return;
    }
    navigate(
      `/order/print-label/${id}/${
        selectedCategorySnapShot?.toString() || "all"
      }`,
      { state: { department_id: activeKey } },
    );
    return;
    // setLoadingPrint(true);
    // setPreviewImage([]);
    // setRenderPrint(true);

    // try {
    //   const departmentsMap = new Map();
    //   const groupedDepartments: any[] = [];

    //   productionJobsData?.forEach((job: any) => {
    //     const deptId = job.department_id?._id?.toString() || "unknown";
    //     if (!departmentsMap?.has(deptId)) {
    //       const deptInfo = {
    //         department: job.department_id || { name: "Unknown Department" },
    //         jobs: [],
    //         weekNumber: null as number | null,
    //       };
    //       departmentsMap?.set(deptId, deptInfo);
    //       groupedDepartments?.push(deptInfo);
    //     }
    //     departmentsMap?.get(deptId)?.jobs?.push(job);
    //   });

    //   // Sort groupedDepartments by position and name
    //   groupedDepartments?.sort((a: any, b: any) => {
    //     const posA = a.department?.position ?? Infinity;
    //     const posB = b.department?.position ?? Infinity;
    //     if (posA !== posB) return posA - posB;
    //     return (a.department?.name || "").localeCompare(
    //       b.department?.name || "",
    //     );
    //   });

    //   const labelDataItems: any[] = [];

    //   groupedDepartments?.forEach((dept) => {
    //     // Sort jobs by start_at
    //     dept.jobs.sort(
    //       (a: any, b: any) =>
    //         new Date(a.start_at).getTime() - new Date(b.start_at).getTime(),
    //     );

    //     if (dept.jobs.length > 0 && dept.jobs[0].start_at) {
    //       dept.weekNumber = getWeekNumber(new Date(dept?.jobs[0].start_at));
    //     }

    //     if(dept?.department?.name.toLowerCase()?.includes("sheet metal")){

    //     }else{

    //     }
    //     dept.jobs.forEach((job: any, index: number) => {
    //       const finishName =
    //         ProductFinishLabels[
    //         job?.product?.variants?.attributes?.finish as ProductFinishEnum
    //         ];
    //       labelDataItems.push({
    //         department_name: dept?.department?.name,
    //         weekNumber: `${dept?.weekNumber || "N/A"}.${index + 1}`,
    //         customer_name: (
    //           (orderDetails?.customer_snapshot?.first_name || "") +
    //           " " +
    //           (orderDetails?.customer_snapshot?.last_name || "")
    //         ).trim(),
    //         order_number: orderDetails?.order_id,
    //         variant_name: job?.product?.variants?.variant_name,
    //         color:
    //           job?.product?.variants?.attributes?.color || finishName || "",
    //         qty: job?.qty,

    //       });
    //     });
    //   });

    //   // Render labels concurrently
    //   const renderPromises = labelDataItems.map(async (data, index) => {
    //     try {
    //       const dynamicXml = injectDataToXml(JobLabelXml, data);
    //       const result = await dymo.renderLabel(dynamicXml);

    //       let base64: any = typeof result === "object" ? result.data : result;

    //       if (base64) {
    //         base64 = base64.replace(/"/g, "");
    //         const baseData = base64.startsWith("data:image")
    //           ? base64
    //           : `data:image/png;base64,${base64}`;

    //         return { XML: dynamicXml, preview: baseData, selected: true, id: index + 1 };
    //       }
    //     } catch (error) {
    //       console.log("Label render failed for", data, error);
    //     }
    //     return null;
    //   });

    //   const results = await Promise.all(renderPromises);
    //   setPreviewImage(results.filter(Boolean));
    // } catch (error) {
    //   console.error("handleRender error:", error);
    //   message.error("Failed to generate label previews.");
    // } finally {
    //   setLoadingPrint(false);
    // }
  };

  const handleDownloadLabels = () => {
    messageApi.open({
      type: "loading",
      content: "Job Labels Download In Progress..",
      duration: 0,
    });
    setDownloadJobLebelsLoading(true);
    dispatch(
      generateJobLebelesAPI({
        payload: {},
        onSuccess: () => {
          setDownloadJobLebelsLoading(false);
          messageApi?.destroy();
        },
        onError: () => {
          setDownloadJobLebelsLoading(false);
          messageApi?.destroy();
        },
      }),
    );
  };
  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <h4 className="fw-bold mb-0 fs-4 d-flex align-items-center gap-2">
          Print Labels
          <div className="d-flex align-items-center gap-1">
            <Tooltip
              title={
                connectionStates?.isConnectSuccess &&
                !connectionStates?.isPrinterError
                  ? `Dymo Service Connected`
                  : connectionStates?.isPrinterError
                  ? "Dymo Service Connected But Printer Not Found"
                  : "Dymo Service Not Connected"
              }
            >
              <span
                className={
                  "d-inline-flex align-items-center billStatus " +
                  (connectionStates?.isConnectSuccess &&
                  !connectionStates?.isPrinterError
                    ? "approvedStatus"
                    : "expiredStatus")
                }
              >
                {/* <span className="svg-14"> */}
                <PrinterOutlined />
                {/* </span> */}
                {connectionStates?.isConnectSuccess &&
                !connectionStates?.isPrinterError
                  ? "Connected"
                  : connectionStates?.isPrinterError
                  ? "Printer Not Found"
                  : "Disconnected"}
              </span>
            </Tooltip>

            <span
              className="svg-16 d-flex align-items-center justify-content-center"
              role="button"
              onClick={() => {
                setRefreshConnection((prev) => prev + 1);
              }}
            >
              <Tooltip title="Refresh Dymo Printer Connection">
                <SyncOutlined spin={connectionLoader} className="ms-1" />
              </Tooltip>
            </span>
          </div>
        </h4>

        <div className="d-flex flex-wrap align-items-center gap-2 ms-sm-auto mob-w-100">
          <div className="whatsBannedDropdown filterCommonDropdown mw-100 d-inline-block">
            <Select
              value={selectedCategorySnapShot}
              popupClassName="full-text-select-dropdown"
              className="form-select form-select-lg"
              onChange={(value) => {
                setSelectedCategorySnapShot(value);
              }}
            >
              <Select.Option value={""}>All</Select.Option>
              {orderDetails?.categories_snapshot?.map((elem: any) => {
                return (
                  <Select.Option value={elem?._id} key={elem?._id}>
                    {elem?.name}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
          {/* <button
            className="btn btn-lg mob-btn btn-primary d-flex align-items-center gap-2 fw-semibold"
            disabled={downloadJobLebelsLoading}
            onClick={handleDownloadLabels}
          >
            <span className="svg-20 d-sm-inline-block d-none">
              {svg?.downlodIcon}
            </span>
            Download Labels
          </button> */}
          <button
            className="btn btn-lg mob-btn btn-primary d-flex align-items-center gap-2 fw-semibold"
            disabled={loadingPrint}
            onClick={handleRender}
          >
            <span className="svg-20 d-sm-inline-block d-none">
              {" "}
              <PrinterOutlined />
            </span>{" "}
            Print Labels
          </button>
          <Tooltip title={downloadLoading ? "Download in progress..." : ""}>
            <div>
              <Dropdown
                menu={{ items: productionSheetMenuItems }}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="moreOptionDropdown"
                open={isSheetDropdownOpen}
                onOpenChange={(flag) => {
                  if (!downloadLoading) {
                    setIsSheetDropdownOpen(flag);
                  }
                }}
                disabled={
                  getOrderProductionDepartmentLoading || downloadLoading
                }
              >
                <button
                  className="btn btn-lg mob-btn btn-primary d-flex align-items-center gap-2 fw-semibold"
                  disabled={
                    getOrderProductionDepartmentLoading || downloadLoading
                  }
                >
                  Download Sheet
                  <span
                    className="svg-16 d-inline-flex align-items-center justify-content-center"
                    style={{ filter: "brightness(0) invert(1)" }}
                  >
                    {svg?.selectDownArrow}
                  </span>
                </button>
              </Dropdown>
            </div>
          </Tooltip>
        </div>

        {contextHolder}
      </div>
      <div className="fs-6 fw-medium">
        <span className="fw-bold text-primary">Notes* :</span>
        {` Please complete Production Planning first. Once production is scheduled, all planned parts, components, and variants will appear here for label printing.`}
      </div>
      {getOrderProductionDepartmentLoading ? (
        <div
          className="w-100 d-flex align-items-center justify-content-center"
          style={{ height: "calc(100vh - 17rem)" }}
        >
          <FullScreenLoader />
        </div>
      ) : (
        <div>
          <div className="customHorizontalTabs jobsDeptTabs bg-white overflow-hidden border-0 rounded-3 d-inline-block mw-100 mb-2">
            {deptTabsCss && <style>{deptTabsCss}</style>}
            <Tabs
              activeKey={activeKey}
              onChange={(key: string) => {
                setActiveKey(key);
              }}
              items={items?.map(({ label, key }) => ({
                label,
                key,
              }))}
            />
          </div>
          <div
            className={`card page-table-card variantsTableCard border-0 shadow rounded-4 flex-fill overflow-hidden`}
          >
            <div className="card-body overflow-y-auto h-100 p-0">
              {getProductionJobsDataLoading ? (
                <div
                  className="w-100 d-flex align-items-center justify-content-center"
                  style={{ height: "calc(100vh - 20rem)" }}
                >
                  <FullScreenLoader />
                </div>
              ) : (
                <Table
                  columns={columns}
                  scroll={isMobile ? { x: "max-content" } : undefined}
                  dataSource={productionJobsData}
                  pagination={false}
                  bordered
                  className="variant-edit-table productionListTable bg-white"
                  size="middle"
                />
              )}
            </div>
          </div>
          {/* <div className="d-flex align-items-center gap-2 mt-2">
           
          </div> */}
        </div>
      )}
      {renderPrint && (
        <PrintPreviewModal
          visible={renderPrint}
          setIsModalVisible={setRenderPrint}
          loading={loadingPrint}
          previewImage={previewImage}
          dymo={dymo}
          cleanXml={JobLabelXml}
          setPreviewImage={setPreviewImage}
          activeKey={activeKey}
        />
      )}
      {isOpenConnectionErrorModal && (
        <PrinterConnectionErrorModal
          visible={isOpenConnectionErrorModal}
          setIsModalVisible={setIsOpenConnectionErrorModal}
          isPrinterError={connectionStates.isPrinterError}
        />
      )}
    </div>
  );
};

export default Jobs;
